import { useMutation, useQuery } from "@tanstack/react-query";
import { ResponseType } from "../../../utils/types";
import { forgotPasswordPayload } from "../../../utils/types";
import { AuthApiService } from "../../../apiService/auth-services.ts";
import NotificationService from "../../../services/NotificationService";

export const useForgotPassword = (onSuccess: (payload: forgotPasswordPayload) => void) => {
    return useMutation<ResponseType, Error, forgotPasswordPayload>({
        mutationFn: (payload: forgotPasswordPayload) => AuthApiService.forgotPassword(payload),
        onSuccess: (res: ResponseType, payload: forgotPasswordPayload) => {
            if (res.ok) {
                onSuccess(payload);
                NotificationService.success("OTP sent to your email successfully.");
                return res.data;
            }
            NotificationService.error(res?.response?.message || "Failed to send OTP. Please try again.");
            throw res?.response?.message;
        },
        onError: (err: any) => {
            throw err;
        }
    });
};
